import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDatasetPermission } from '@euler/model/bi/dataset';
import { X } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../../../components/ui/BiButton';
import { BiChip } from '../../../components/ui/BiChip';
import { kBiDatasetGrantLabels } from '../../functions/biLibraryText';

const kPermissions = [BiDatasetPermission.Use, BiDatasetPermission.Manage];

/** A named member's grant: use or manage, or removed. */
export const DatasetGrantRow = memo(
  ({
    name,
    permission,
    onChange,
    onRemove,
  }: {
    name: string;
    permission: BiDatasetPermission;
    onChange: (permission: BiDatasetPermission) => void;
    onRemove: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(8),
          paddingVertical: rpx(8),
          borderBottomWidth: 1,
          borderBottomColor: aiColors.border,
        }}
      >
        <Typography.Text
          size={rpx(13)}
          color={aiColors.foreground}
          numberOfLines={1}
          style={{ flex: 1 }}
        >
          {name}
        </Typography.Text>
        {kPermissions.map(value => (
          <BiChip
            key={value}
            label={kBiDatasetGrantLabels[value]}
            selected={permission === value}
            onPress={() => onChange(value)}
          />
        ))}
        <BiButton
          icon={X}
          tone="quiet"
          accessibilityLabel={`移除 ${name}`}
          onPress={onRemove}
        />
      </View>
    );
  },
);
